// extracted by mini-css-extract-plugin
export default {"car":"style_car__p41MW","buttonClass":"style_buttonClass__Wl+oI","description":"style_description__oHO-J"};